import React, { useState } from "react";

import PropTypes from "prop-types";

import "./faq-work-with-us.css";

const FAQWorkWithUs = (props) => {
  const [faq2Visible, setFaq2Visible] = useState(false);
  const [faq1Visible, setFaq1Visible] = useState(false);
  const [faq3Visible, setFaq3Visible] = useState(false);
  const [faq4Visible, setFaq4Visible] = useState(false);
  const [faq5Visible, setFaq5Visible] = useState(false);
  return (
    <div
      className={`faq-work-with-us-faq8 thq-section-padding ${props.rootClassName} `}
    >
      <div className="faq-work-with-us-column">
        <span className="faq-work-with-us-text10">{props.text}</span>
        <div className="faq-work-with-us-max-width thq-section-max-width">
          <div className="faq-work-with-us-container10 thq-flex-column">
            <div className="thq-flex-column thq-section-max-width">
              <div className="thq-divider-horizontal"></div>
              <div className="faq-work-with-us-faq1">
                <div
                  onClick={() => setFaq1Visible(!faq1Visible)}
                  className="faq-work-with-us-trigger1"
                >
                  <p className="faq-work-with-us-faq1-question thq-body-large">
                    {props.faq1Question}
                  </p>
                  <div className="faq-work-with-us-icons-container1">
                    {faq1Visible === false && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-work-with-us-icon10"
                        >
                          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                        </svg>
                      </div>
                    )}
                    {faq1Visible === true && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-work-with-us-icon12"
                        >
                          <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
                {faq1Visible === true && (
                  <div className="faq-work-with-us-container13">
                    <span className="thq-body-small">
                      To apply as a CashOver Agent, simply fill out the contact
                      form below or send us an email at{" "}
                      <a
                        style={{
                          textDecoration: "underline",
                          color: "#0b6ef9ff",
                        }}
                        href="mailto:contactus@cashover.money"
                        className="email-link"
                      >
                        contactus@cashover.money
                      </a>
                      . Our team will review your application, ask a few
                      eligibility questions, and get back to you with the next
                      steps.
                    </span>
                  </div>
                )}
              </div>
              <div className="thq-divider-horizontal"></div>
              <div className="faq-work-with-us-faq2">
                <div
                  onClick={() => setFaq2Visible(!faq2Visible)}
                  className="faq-work-with-us-trigger2"
                >
                  <p className="faq-work-with-us-faq2-question1 thq-body-large">
                    {props.faq2Question}
                  </p>
                  <div className="faq-work-with-us-icons-container2">
                    {faq2Visible === false && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-work-with-us-icon14"
                        >
                          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                        </svg>
                      </div>
                    )}
                    {faq2Visible === true && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-work-with-us-icon16"
                        >
                          <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
                {faq2Visible === true && (
                  <div className="faq-work-with-us-container16">
                    <span className="thq-body-small">
                      To host a CashOver ATM, please fill out the contact form
                      below or send us an email at{" "}
                      <a
                        style={{
                          textDecoration: "underline",
                          color: "#0b6ef9ff",
                        }}
                        href="mailto:contactus@cashover.money"
                        className="email-link"
                      >
                        contactus@cashover.money
                      </a>
                      . You will need to meet certain requirements before your
                      application is approved.
                    </span>
                  </div>
                )}
              </div>
              <div className="thq-divider-horizontal"></div>
              <div className="faq-work-with-us-faq3">
                <div
                  onClick={() => setFaq3Visible(!faq3Visible)}
                  className="faq-work-with-us-trigger3"
                >
                  <p className="faq-work-with-us-faq2-question2 thq-body-large">
                    {props.faq3Question}
                  </p>
                  <div className="faq-work-with-us-icons-container3">
                    {faq3Visible === false && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-work-with-us-icon18"
                        >
                          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                        </svg>
                      </div>
                    )}
                    {faq3Visible === true && (
                      <div>
                        <svg
                          viewBox="0 0 1024 1024"
                          className="faq-work-with-us-icon20"
                        >
                          <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
                {faq3Visible === true && (
                  <div className="faq-work-with-us-container19">
                    <span className="thq-body-small">
                      How much money you make depends on several factors, like
                      volume processed, invoices processed and overall behavior.
                    </span>
                  </div>
                )}
              </div>
              <div className="thq-divider-horizontal"></div>
            </div>
          </div>
          <div className="faq-work-with-us-content thq-flex-column thq-section-max-width">
            <h2 className="faq-work-with-us-text18">{props.heading2}</h2>
            <p className="faq-work-with-us-text19">{props.content2}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

FAQWorkWithUs.defaultProps = {
  faq3Question: "How much money can I make?",
  faq1Question: "How can I become a CashOver Agent?",
  heading2: "Still have a question?",
  text: "FAQ",
  rootClassName: "",
  faq2Question: "How can I host a CashOver ATM?",
  content2: "Do not hesitate to contact us to answer your inquiries",
};

FAQWorkWithUs.propTypes = {
  faq3Question: PropTypes.string,
  faq1Question: PropTypes.string,
  heading2: PropTypes.string,
  text: PropTypes.string,
  rootClassName: PropTypes.string,
  faq2Question: PropTypes.string,
  content2: PropTypes.string,
};

export default FAQWorkWithUs;
